const utils = require('frontend-controller/lib/utils')
const ClientError = require('frontend-controller/client/error')

module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'form'
    ],

    config: {
        resourceRegisterKey: 'entityPartParent',
        loadWhenPrimaryKeyPresentOnly: true,

        hideWhenPrimaryKeyPresent: null,
    },

    model: {
        ninjaModule: '',            // actual ninjaModule (e.g., news)
        ninjaModuleConfig: {},      // actual ninjaModuleConfig defined by web-projects clientAppConfig (e.g., appConfig.ninjaModules.news)

        entityController: null,     // parent entityController
        propertiesForm: null,       // propertiesFrom of the actual entity
        langCode: '',               // actual langCode

        startWithRegisterSecret: null, // the separationList used may start with this registerSecret to autoOpen the right one.
    },

    methods: {
        onBuild(storage){
            if(storage.isServer){
                return;
            }

            if(!this.model.ninjaModule){
                this.closest('templates_ninja_controller', controller => {
                    const {
                        ninjaModule,
                        ninjaModuleConfig
                    } = controller.getNinjaModuleParams()
                    this.model.ninjaModule = ninjaModule
                    this.model.ninjaModuleConfig = ninjaModuleConfig

                    // use modelName as fallback for privilegeBase
                    const modelName = (ninjaModuleConfig.db || {}).entityPartModelName
                    if(modelName && !this.config.privilegeBase){
                        this.config.privilegeBase = modelName
                    }
                }, true)

                this.model.langCode = this.getResourceRegisterContent('entityPartLangCode')
                this.closest('templates_ninja_entityController', controller => {
                    this.model.entityController = controller
                }, true)
            }
        },

        /**
         * this function will be called after sanitizeResources().
         * since this is the perfect place to manipulate the form's behaviour according to the given resources one may overwrite this skeleton function to do that.
         *
         * @param storage		object - actual storage
         */
        onResourceSanitized(storage){
            const data = this.resourceData.data || {}
            const attributes = data.attributes || {}
            const primaryKey = attributes[data.primaryKey || 'id']

            // hide this form if primaryKey is already present if necessary
            if(this.config.hideWhenPrimaryKeyPresent && primaryKey){
                this.config.contextClass = [this.config.contextClass || '']
                    .concat(['preventRender'])
                    .join(' ')
            }
        },

        ensurePropertiesForm(){
            if(this.model.entityController && !this.model.propertiesForm){
                this.model.entityController.find('templates_ninja_propertiesForm', c => this.model.propertiesForm = c)
            }
        },

        /**
         * will be called right before sanitizeForm() is done
         */
        onBeforeSanitizeForm(storage){
            if(storage.isServer){
                return
            }

            const ninjaModuleConfig = this.model.ninjaModuleConfig
            const entityPrimaryKeyName = (ninjaModuleConfig.db || {}).entityPrimaryKeyName
            const entityPartRouteIDFieldName = (ninjaModuleConfig.db || {}).entityPartRouteIDFieldName

            // hide this form if primaryKey is already present if necessary
            if(this.config.hideWhenPrimaryKeyPresent === null){
                this.config.hideWhenPrimaryKeyPresent = utils.collectionSize(this.model.fields) < 1
            }

            const fields = this.model.fields = this.model.fields || []
            fields.push({
                atom: {
                   dataType: 'text',
                },
                fieldCode: 'langCode'
            })
            fields.push({
                atom: {
                   dataType: 'integer',
                },
                fieldCode: entityPrimaryKeyName,
            })
            fields.push({
                atom: {
                   dataType: 'integer',
                },
                fieldCode: entityPartRouteIDFieldName,
            })
        },

        onAttachDone: function(){
            if(this.config.creationMode && this.resourceData.dirtyFields){
                for(const fieldCode in this.resourceData.dirtyFields){
                    this.fieldToModel(fieldCode, this.resourceData.dirtyFields[fieldCode])
                }
            }
        },

        onChange: function(isRelationChange, changeDone, fieldData){
            if((fieldData || {}).fieldCode === 'title') {
                this.ensurePropertiesForm()
                if(this.model.langCode && this.model.propertiesForm){
                    this.model.propertiesForm.updateTabTitle(this.model.langCode, (fieldData || {}).fieldValue || '')
                }
            }
        },

        prepareForSubmit(){
            return this.ensureRoute()
                .then(result => utils.promise.resolve(result))
                .fail(error => utils.promise.reject(error))
        },

        onSubmit(response){
            const data = (response || {}).data || {}
            const attributes = data.attributes || {}
            const entityPartID = attributes[data.primaryKey || 'id']
            const entityPartRouteIDFieldName = (this.model.ninjaModuleConfig.db || {}).entityPartRouteIDFieldName
            const routeID = attributes[entityPartRouteIDFieldName || 'missingRouteID']

            if(this.model.entityController){
                this.model.entityController.updatePartState(this.model.langCode, routeID || undefined, undefined, entityPartID, attributes.title, this.model.startWithRegisterSecret)
            }
        },



        ////////////////////
        /// customs
        ////////////////////

        getRouteName(dirtyOnly = true){
            return this.getFieldValue('title', dirtyOnly ? 'dirty' : undefined)
        },

        updateRouteID(routeID){
            if(!routeID){
                return utils.promise.reject(new ClientError('ENTITY_PART_PROPERTIES_MISSING_ROUTE_ID'))
            }
            const entityPartRouteIDFieldName = (this.model.ninjaModuleConfig.db || {}).entityPartRouteIDFieldName
            if(!entityPartRouteIDFieldName){
                return utils.promise.reject(new ClientError('ENTITY_PART_PROPERTIES_MISSING_ROUTE_ID_FIELD_NAME'))
            }

            this.fieldToModel('routeID', routeID)
        },

        ensureRoute(isManualCreate = false){
            if(!this.model.langCode){
                return utils.promise.reject(new ClientError('ENTITY_PART_PROPERTIES_LANG_CODE_MISSING'))
            }
            if(!this.model.entityController){
                return utils.promise.reject(new ClientError('ENTITY_PART_PROPERTIES_ENTITY_CONTROLLER_MISSING'))
            }
            const entityPartRouteIDFieldName = (this.model.ninjaModuleConfig.db || {}).entityPartRouteIDFieldName
            if(!entityPartRouteIDFieldName){
                return utils.promise.reject(new ClientError('ENTITY_PART_PROPERTIES_ROUTE_ID_FIELDNAME_MISSING'))
            }

            const actualRouteID = (((this.resourceData || {}).data || {}).attributes || {})[entityPartRouteIDFieldName]

            return this.model.entityController.ensureRoute(this.model.langCode, actualRouteID, this, isManualCreate)
                .then(result => {
                    if((result || {}).routeCreationPreventedIntentionally || actualRouteID){
                        return utils.promise.resolve(result)
                    }

                    const data = ((result || {}).response || {}).data || {}
                    const attributes = data.attributes || {}
                    const routeID = attributes[data.primaryKey || 'id']
                    const templateID = attributes.templateID

                    this.updateRouteID(routeID)
                    this.model.entityController.updatePartState(this.model.langCode, routeID || undefined, templateID || undefined, undefined, undefined, undefined, true)

                    return utils.promise.resolve(result)
                })
                .fail(error => utils.promise.reject(error))
        },
    },

    handlers: [
        {
            name: 'afterCancel',
            componentClass: 'templates_ninja_partPropertiesForm',
            handle: function(callerComponent){
                if(callerComponent.componentIndex === this.componentIndex){
                    this.refresh()
                }
            }
        },
    ],
}
